<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->


        <h2>Cadastro de Assuntos</h2>
        <p>Esta tela é destinada ao cadastro de assuntos e suas subáreas.</p>

        <button @click="openAddForm(null);" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
            <span class="material-icons" style="vertical-align: middle; color: #007BFF;">add</span>
            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Área de Assunto</label>
        </button>

        <AssuntoForm v-if="showForm" :assunto="selectedAssunto" :parent_id="parent_id" @closeForm="closeForm" />

        <div v-if="!showForm" style="height: 160px;"></div>

        <AssuntoTree :assuntos="assuntos" 
                 @addSubassunto="openAddForm" 
                 @editAssunto="openEditForm" 
                 @deleteAssunto="confirmDelete" />
      
    </div>
  </template>
  
<script>
import axios from 'axios';
import AssuntoTree from './AssuntoTree.vue';
import AssuntoForm from './AssuntoForm.vue';

export default {
    components: {
        AssuntoTree,
        AssuntoForm
    },
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            showForm: false,
            selectedAssunto: null,
            parent_id: null,
        };
    },
    props: {
        assuntos: Array,
        user: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        
    },
    methods: {
        closeForm() {
            this.showForm = false;
            this.selectedAssunto = null;
        },

        openAddForm(parentId, label_descricao) {
            this.selectedAssunto = { parentId: parentId };
            this.selectedAssunto.label_descricao = label_descricao;
            this.showForm = true;
        },
        openEditForm(assunto) {
            this.selectedAssunto = assunto;
            this.showForm = true;
        },
        confirmDelete(assuntoId) {
            if (confirm('Confirma a exclusão deste assunto e os subassuntos?\n\nATENÇÃO! Os assuntos são hierarquizados, ao deletar um assunto todos seus subassuntos serão deletados se existirem.')) {

                axios.delete(this.BASE_URL + 'assunto_deletar/' + assuntoId)
                    .then(response => {
                        if (response.status === 200) {
                            alert('Exclusão efetivada com sucesso!');
                            window.location.reload();
                        } else {
                            alert('Erro ao gravar dados.');
                        }
                    })
                    .catch(error => {
                        alert('Erro ao gravar dados: ' + error);
                        console.error(error);
                    });

            }
        },





    },

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente About aqui se necessário */
</style>
